
export class Media {

    baseUrl: string;
    hash: string;
    mime: string;
    name: string;
    path: string
    phash: string;
    size: number;
    ts: number;
    url: string;
    constructor() {
        this.url = "";
    }

   

}
